import React, { Component } from "react";
import Image from "react-bootstrap/Image";
import moment from "moment";
import {
  TotalNumberSmallBox,
  TotalNumberSmallDateRange,
} from "../reusableReports/TotalNumberSmallBox";
import ReportsStackedChart from "./charts/ReportsStackedChart";
import { ReportsLiveChart } from "./charts/ReportsLiveChart";
import ReportsDonutChart from "./charts/ReportsDonutChart";

export class ReportsDashboardOne extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="col-12 p-0">
          <div>
            <h4>Seating Report Live Dashboard</h4>
          </div>
        </div>
        <div
          onClick={this.props.onClick}
          className="col-12 seating-report-dashboard-live"
        >
          <div className="row">
            <div className="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10">
              <div className="d-flex align-items-end">
                <div className="live-button-css">
                  <p className="live-text">Live</p>
                </div>
                <p className="date-year-month">
                  {moment(new Date()).format("DD MMMM YYYY")}
                </p>
              </div>
              <div>
                <ReportsLiveChart
                  iconImage={require("../../../../../assets/images/ActionImages/walking-img.svg")}
                  altText="Seating Record"
                  titleText="Seating Record"
                  imageClass="progress-bar-icon-imageone"
                  headingText="Walk-in"
                  paragraphText="Total number of People 30"
                  now="30"
                  progressBar="main-progress-bar-sectiontwo"
                />
                <ReportsLiveChart
                  iconImage={require("../../../../../assets/images/Icon/waitlist.png")}
                  altText="Seating Record"
                  titleText="Seating Record"
                  imageClass="progress-bar-icon-imagetwo"
                  headingText="Waitlist"
                  paragraphText="Total number of People 30"
                  now="40"
                  progressBar="main-progress-bar-sectionthree"
                />
                <ReportsLiveChart
                  iconImage={require("../../../../../assets/images/Icon/reservationBlack.png")}
                  altText="Seating Record"
                  titleText="Seating Record"
                  imageClass="progress-bar-icon-imagethree"
                  headingText="Reservation"
                  paragraphText="Total number of People 40"
                  now="50"
                  progressBar="main-progress-bar-sectionfour"
                />
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <TotalNumberSmallBox
                mainBoxOne="reports-dashboard-small-boxtotal"
                displayBox="display-box-all"
                colorBoxOne="color-box-one color-green"
                colorBoxTwo="color-box-one color-yellow"
                colorBoxThree="color-box-one color-light-green"
                headingText="heading-text-one"
                valueText="value-text-one"
                walkinValue="40"
                waitlistValue="30"
                reservationValue="30"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
            <div>
              <h4>Seating Report Hourly by Day</h4>
            </div>
            <div className="col-12 seating-report-hourly-day">
              <div className="row">
                <div
                  onClick={this.props.onClick}
                  className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9"
                  style={{ cursor: "pointer" }}
                >
                  <ReportsStackedChart />
                </div>
                <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div>
                    <p className="time-char-bar">
                      Time {moment(new Date()).format("LT")}
                    </p>
                  </div>
                  <TotalNumberSmallBox
                    mainBoxOne="reports-dashboard-small-boxtotal reports-custom-main-padding"
                    displayBox="display-box-all"
                    colorBoxOne="color-box-two color-green"
                    colorBoxTwo="color-box-two color-yellow"
                    colorBoxThree="color-box-two color-light-green"
                    headingText="heading-text-two"
                    valueText="value-text-two reports-custom-value-text"
                    walkinValue="40"
                    waitlistValue="30"
                    reservationValue="30"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <div>
              <h4>Seating Report for Date Range</h4>
            </div>
            <div className="col-12 seating-report-date-range">
              <div className="row">
                <div className="col">
                  <div className="from-date">
                    <div>
                      <Image
                        fluid
                        src={require("../../../../../assets/images/ActionImages/calendar.png")}
                        alt="Previous Date"
                        title="Previous Date"
                      />
                      <p>From</p>
                    </div>
                    <div className="date-display-box">
                      <h5>
                        09 <span>Mar 20 Monday</span>
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="from-date">
                    <div>
                      <Image
                        fluid
                        src={require("../../../../../assets/images/ActionImages/calendar.png")}
                        alt="Previous Date"
                        title="Previous Date"
                      />
                      <p>To</p>
                    </div>
                    <div className="date-display-box">
                      <h5>
                        10 <span>Mar 20 Tuesday</span>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <ReportsDonutChart />
              <TotalNumberSmallDateRange
                leftSmallText="Total number of People 36"
                middleSmallText="Rejected"
                middleBottomValue="20"
                rightSmallText="Cancelled"
                rightBottomValue="20"
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ReportsDashboardOne;
